import {
  GeneratePaymentStatementLinkMutation,
  GeneratePaymentStatementLinkMutationVariables,
} from '@/types';
import { gql, useMutation } from '@apollo/client';

export const GENERATE_STATEMENT_MUTATION = gql`
  mutation generatePaymentStatementLink(
    $employeeUUID: uuid!
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    generatePaymentStatementLink(
      employee_id: $employeeUUID
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      payment_statement_url
    }
  }
`;

export const useGenerateStatement = () => {
  return useMutation<
    GeneratePaymentStatementLinkMutation,
    GeneratePaymentStatementLinkMutationVariables
  >(GENERATE_STATEMENT_MUTATION);
};
